import { mapState } from 'vuex';

import { filterGroups } from '@/utils';

export const videosMixin = (type = 'pre-training') => ({
  data() {
    return {
      serie: {},
      videoTitle: '',
      showModal: false,
      videosLoading: false,
    };
  },
  computed: mapState({
    series: state =>
      filterGroups(state.admin.series, type === 'pre-training' ? 'Chroma' : 'Chroma Plus+Luxe'),
    language: state => state.language,
    isViewRoute() {
      return this.isRoute('view');
    },
  }),
  watch: {
    $route() {
      if (!this.isRoute('edit')) this.videoTitle = '';
    },
  },
  methods: {
    isRoute(path) {
      const re = {
        'post-training-videos': {
          view: /^\/admin\/post-training-videos\/view\/?.*/g,
          edit: /^\/admin\/post-training-videos\/edit\/?.*/g,
        },
        'training-videos': {
          view: /^\/admin\/training-videos\/view\/?.*/g,
          edit: /^\/admin\/training-videos\/edit\/?.*/g,
        },
        'pre-training': {
          view: /^\/admin\/pre-training\/view\/?.*/g,
          edit: /^\/admin\/pre-training\/edit\/?.*/g,
        },
      };

      return re[type][path].test(this.$route.path);
    },
    navigateTo(id) {
      const to = {
        'pre-training': `/admin/pre-training/view/${id}`,
        'post-training-videos': `/admin/post-training-videos/view/${id}`,
        'training-videos': `/admin/training-videos/view/${id}`,
      };
      if (to[type] !== this.$route.path) this.$router.push(to[type]);
    },
    async handleSerie(serie) {
      this.serie = serie;
      this.navigateTo(serie.id);
    },
    handleClose() {
      this.$emit('close');
    },
  },
  async mounted() {
    this.videosLoading = true;

    // keep series in global state as it is used in multiple pages and there's not need to re-fetch
    let series = this.$store.state.admin.series;

    if (!series.length) {
      series = await this.$store.dispatch('admin/getSeries');
    }

    this.serie = series[0];
    this.videosLoading = false;

    this.navigateTo(series[0].id);
  },
});
